import { render } from "./OrderModalItem.vue?vue&type=template&id=418d26f8"
import script from "./OrderModalItem.vue?vue&type=script&lang=js"
export * from "./OrderModalItem.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_4ea0b76e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__